import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_HUMAN_VERIFICATION = createFcmConfig('enable_human_verification', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
